import {
  CubeReducerState,
  DisabledReason,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

/**
 * Whether an amendment quote is holding this schedule. The API refuses every
 * edit and the archive until that quote is executed or dropped, so a locked
 * schedule is no more editable than a cancelled or completed one, and the
 * features that already refuse those refuse this the same way.
 */
export const isLockedByAmendment = (prevState: CubeReducerState): boolean =>
  Boolean(prevState.data.common.lockedByQuoteId)

export const amendmentLockReason = (
  prevState: CubeReducerState
): DisabledReason => ({
  reasonType: DisabledReasonType.ScheduleLockedByAmendment,
  metadata: { lockedByQuoteId: prevState.data.common.lockedByQuoteId }
})

/**
 * Takes a feature's own answer and switches it off while the schedule is
 * locked, keeping whatever that feature decided about `visible` and why. A
 * locked schedule should look like any other, just with nothing on it you can
 * change - so the lock never hides a control that would otherwise show, nor
 * shows one that wouldn't.
 */
export const disableIfLockedByAmendment =
  (prevState: CubeReducerState) =>
  (feature: VisibleEnabledFeatureAvailable): VisibleEnabledFeatureAvailable => {
    if (!isLockedByAmendment(prevState)) {
      return feature
    }

    return {
      available: {
        visible: feature.available.visible,
        enabled: false
      },
      reasons: [amendmentLockReason(prevState), ...feature.reasons]
    }
  }
